import { render, staticRenderFns } from "./HeaderCircleButtons.vue?vue&type=template&id=056b0530"
import script from "./HeaderCircleButtons.vue?vue&type=script&lang=js"
export * from "./HeaderCircleButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports